import { Grid } from "@mui/material";

import { Dashboard } from "@/lib/api";
import AvatarCard from "@/features/shared/components/avatar-card/avatar-card";

const OrganisationsDetailCards = ({ dashboards }: { dashboards: Dashboard[] }) => {
  return (
    <Grid container spacing={{ xs: 2, sm: 3 }}>
      {dashboards.map((dashboard: Dashboard) => {
        return (
          <Grid item xs={12} sm={6} md={4} key={dashboard.id}>
            <AvatarCard
              to={"/admin/dashboard/" + dashboard.id}
              name={dashboard.name}
              tags={[dashboard.extranet.name]}
            />
          </Grid>
        );
      })}
    </Grid>
  );
};

export default OrganisationsDetailCards;
